<div id="establishment-details-buildings-card" class="card mt-6">
  <div class="px-gutter py-4 border-b" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="title m-0">{{ entityName }}</h2>

    <button
      [permissionBlock]="[ENUM_PERMISSIONS.UPDATE_BUILDING]"
      color="primary"
      mat-raised-button
      type="button"
      (click)="addBuilding()"
    >
      AJOUTER
    </button>
  </div>

  <div @stagger class="px-gutter py-4">
    <base-data-table
      [showPaginator]="true"
      [count]="count"
      [sortField]="sortField"
      [sortOrder]="sortOrder"
      [dataSource]="dataSource"
      [displayedColumns]="displayedColumns"
      [feisColumns]="feisColumns"
      (onPageEvent)="pageEvent($event)"
      (onSortEvent)="sortEvent($event)"
      (onRowClick)="navigateToBuildingDetail($event)"
      [actionsTemplate]="actions"
      [customColumnTemplate]="customColumnTemplateRef"
    ></base-data-table>
    <ng-template #actions let-row="value">
      <button class="mat-menu-item" (click)="updateBuilding(row)">
        <mat-icon>visibility</mat-icon>
        Modifier
      </button>
      <button class="mat-menu-item" (click)="unlinkBuilding(row)">
        <mat-icon>link_off</mat-icon>
        Délier le bâtiment
      </button>
    </ng-template>
    <ng-template #customColumnTemplateRef let-column let-row="element" let-status="status">
      <ng-container *ngIf="column === 'attentionRequiered'">
        <icon-warning [show]="row.isAttentionRequired" [toolTip]="row.attentionRequieredTooltip"></icon-warning>
      </ng-container>
    </ng-template>
  </div>
</div>
